import { HttpClient } from '@angular/common/http';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { TitleCasePipe } from '@angular/common';
import { HeightService } from '../height/height.service';
import { PanelStylesService } from '../panel-styles/panel-styles.service';
import { MaterialService } from '../material/material.service';
import { WorksurfaceService } from '../worksurface/worksurface.service';
import domtoimage from 'dom-to-image';


import { Height } from '../height/height';
import { PanelStyles } from '../panel-styles/panel-styles';
import { Material } from '../material/material';
import { Worksurface } from '../worksurface/worksurface';

@Component({
  selector: 'app-selections-accordion',
  imports: [TitleCasePipe, Height, PanelStyles, Material, Worksurface],
  templateUrl: './selections-accordion.html',
  styleUrl: './selections-accordion.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectionsAccordion {
  protected subSteps = ['A', 'B', 'C', 'D', 'E', 'F'];
  private http = inject(HttpClient);

  private heightService = inject(HeightService);
  private panelStylesService = inject(PanelStylesService);
  protected materialService = inject(MaterialService);
  protected worksurfaceService = inject(WorksurfaceService);

  protected selectedHeight = computed(() => this.heightService.selectedHeight());
  protected selectedPanelStyle = computed(() => this.panelStylesService.selectedStyle());
  protected selectedWorksurface = computed(() => this.worksurfaceService.selectedWorksurface());

  readonly zones = computed(() => {
    const height = this.heightService.selectedHeight();
    const style = this.panelStylesService.selectedStyle();

    let result = ['T3', 'T2', 'T1', 'T0'];

    if (height == 32) {
      result = result.filter(tab => tab !== 'T3');
      result = result.filter(tab => tab !== 'T2');
      if (style?.endsWith('B')) result = result.filter(tab => tab !== 'T1');
    } else if (height === 39) {
      result = result.filter(tab => tab !== 'T3');
      if (style?.endsWith('B') || style?.endsWith('D')) result = result.filter(tab => tab !== 'T2');
      if (style?.endsWith('C') || style?.endsWith('D')) result = result.filter(tab => tab !== 'T1');
    } else if (height === 52 || height === 65) {
      if (style?.endsWith('B') || style?.endsWith('D') || style?.endsWith('F') || style?.endsWith('H')) {
        result = result.filter(tab => tab !== 'T3');
      }
      if (style?.endsWith('C') || style?.endsWith('D') || style?.endsWith('G') || style?.endsWith('H')) {
        result = result.filter(tab => tab !== 'T2');
      }
      if (style?.endsWith('E') || style?.endsWith('F') || style?.endsWith('G') || style?.endsWith('H')) {
        result = result.filter(tab => tab !== 'T1');
      }
    }

    return result;
  });

  protected selections = computed(() =>
    this.zones().map(zone => ({
      zone,
      ...this.materialService.getSelection(zone)()
    }))
  );

  protected getColorLabel = this.materialService.getColorLabel.bind(this.materialService);

  toggleAccordion(index: number): void {
    (window as any).toggleAccordion(index);
  }

  async downloadPanel(): Promise<void> {
    const node = document.getElementById('panel-visuals');

    if (!(node instanceof HTMLElement)) {
      console.error('Element with id "panel-visuals" was not found.');
      return;
    }

    try {
      const dataUrl = await domtoimage.toPng(node, {
        cacheBust: true,
        bgcolor: 'transparent',
      });

      const link = document.createElement('a');
      link.href = dataUrl;
      link.download = 'panel-visuals.png';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Failed to capture panel-visuals:', error);
    }
  }

  hideSuccess() {
    document.getElementById('email_good')?.classList.add('hidden');
  }

  emailSelection() {
    console.log("Email Button Clicked!");
    (document.getElementById('send_email') as HTMLButtonElement).disabled = true;
    (document.getElementById('send_email') as HTMLButtonElement).textContent = 'Sending...';
    let domain = window.location.hostname;
    const first_name = (document.getElementById('first-name') as HTMLInputElement).value;
    const last_name = (document.getElementById('last-name') as HTMLInputElement).value;
    const email = (document.getElementById('email') as HTMLInputElement).value;
    const height = (document.getElementById('height') as HTMLInputElement).value;
    const style = (document.getElementById('style') as HTMLInputElement).value;
    const worksurface = (document.getElementById('worksurface') as HTMLInputElement).value;

    let t4 = "";
    if (document.getElementById('T4')) t4 = (document.getElementById('T4') as HTMLInputElement).value;
    else t4 = "NA";

    let t3 = "";
    if (document.getElementById('T3')) t3 = (document.getElementById('T3') as HTMLInputElement).value;
    else t3 = "NA";

    let t2 = "";
    if (document.getElementById('T2')) t2 = (document.getElementById('T2') as HTMLInputElement).value;
    else t2 = "NA";

    let t1 = "";
    if (document.getElementById('T1')) t1 = (document.getElementById('T1') as HTMLInputElement).value;
    else t1 = "NA";

    let t0 = "";
    if (document.getElementById('T0')) t0 = (document.getElementById('T0') as HTMLInputElement).value;
    else t0 = "NA";

    console.log(first_name, last_name, email);
    console.log(t4);
    console.log(t3);
    console.log(t2);
    console.log(t1);
    console.log(t0);

    const data = {
      domain: domain,
      first_name: first_name,
      last_name: last_name,
      email: email,
      worksurface: worksurface,
      height: height,
      style: style,
      t4: t4,
      t3: t3,
      t2: t2,
      t1: t1,
      t0: t0,
    };

    this.http.post('https://' + domain + '/send_email.php', data)
      .subscribe(res => {
        console.log(res);
        document.getElementById('email_good')?.classList.remove('hidden');
        (document.getElementById('send_email') as HTMLButtonElement).disabled = false;
        (document.getElementById('send_email') as HTMLButtonElement).textContent = 'Send';
      });
  }
}
